import React, { useState, useEffect } from 'react';
import { __ } from '@wordpress/i18n';
import { Toast } from '../../components/common/Toast';
import MainPageLayout from '../../components/common/MainPageLayout';
import GCookieSettings from './components/GCookieSettings';
import BlockServices from './components/BlockServices';
import { CookieBlock, GeneralInfoIcon, GeneralInformationIcon } from '../../components/common/SvgIcon';

const CookieSettings = () => {
  const [activeTab, setActiveTab] = useState(() => {
    return localStorage.getItem('legal_pages_cookie_settings_tab') || 'general';
  });
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    localStorage.setItem('legal_pages_cookie_settings_tab', activeTab);
  }, [activeTab]);

  const tabs = [
    { id: 'general', label: 'General Settings', icon: (< GeneralInformationIcon />)},
    { id: 'block_services', label: 'Block Services', icon: (<CookieBlock />)},
  ];

  return (
    <MainPageLayout
      title="Cookie Bar Settings"
      description="Configure EU cookie consent bar for GDPR compliance"
    >
      {/* Tabs */}
      <div className="mt-6 mb-6">
        <div className="inline-flex rounded-xl bg-[#F4F4F5] p-[4px]">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={[
                'relative flex cursor-pointer items-center gap-2 rounded-xl px-6 py-3 text-sm font-medium transition',
                activeTab === tab.id
                  ? 'bg-white text-[#17171C] shadow-[0px_1px_2px_0px_#0000000D] ring-1 ring-gray-200'
                  : 'text-gray-600 hover:text-gray-900',
              ].join(' ')}
            >
              {tab.icon}
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {activeTab === 'general' && (
        <GCookieSettings isLoading={isLoading} setIsLoading={setIsLoading} />
      )}
      {activeTab === 'block_services' && (
        <BlockServices isLoading={isLoading} setIsLoading={setIsLoading} />
      )}
    </MainPageLayout>
  );
};

export default CookieSettings;